// extracted by mini-css-extract-plugin
export var accordionBox = "index-module--accordionBox--heUUP";
export var accordionTitle = "index-module--accordionTitle--ajyAs";
export var closedBox = "index-module--closedBox--rB30V";
export var container = "index-module--container--IcRad";
export var description = "index-module--description--DH7Qw";
export var expand = "index-module--expand--I7VdZ";
export var expandedBox = "index-module--expandedBox--LONMS";
export var imageLabels = "index-module--imageLabels--9tKqK";
export var imagePane = "index-module--imagePane--KJkQm";
export var info = "index-module--info--4U29M";
export var mobileImagePreview = "index-module--mobileImagePreview--G7TAJ";
export var openedBox = "index-module--openedBox--0Qssp";
export var section = "index-module--section--F25YB";
export var shrink = "index-module--shrink--v3GVY";
export var subtitle = "index-module--subtitle--1BL6Q";
export var title = "index-module--title--vleln";
export var titleBox = "index-module--titleBox--LVU6e";